export default "__VITE_ASSET__e1131205__"